import { TranslationPages_Home__get_Books, TranslationPages_Home__get_Bazaar, TranslationPages_Home__get_Products, TranslationPages_Home__get_Login, TranslationPages_Home__get_Admin, AppTranslations__get_Home, TranslationPages_Home__get_About, AppTranslations__get_IsEmpty } from "../Shopfoo.Shared/Translations.js";
import { class_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { join, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import { equals, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Page_ProductIndexDefaultsWith_Z3D62F06A, Page, Page__get_Key } from "../Routing.js";
import { append, singleton, empty, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Router_goToUrl, $007CPageUrl$007C } from "../Routing.js";
import { map, defaultArgWith } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { ofArray, singleton as singleton_1, append as append_1 } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Filters__ToBooks, Filters__ToBazaar_Z3BF3079, Filters__ClearSearchSort } from "../Filters.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";

class Nav {
    constructor(currentPage, translations) {
        this.currentPage = currentPage;
        this.translate = (AppTranslations__get_IsEmpty(translations) ? ((_arg) => "") : ((f) => f(translations)));
    }
}

function Nav_$reflection() {
    return class_type("Shopfoo.Client.Components.AppNav.Nav", undefined, Nav);
}

function Nav_$ctor_748E64BE(currentPage, translations) {
    return new Nav(currentPage, translations);
}

function Nav__page_Z3BF6DD84(nav, page, text, cssClass) {
    let elems;
    if (isNullOrWhiteSpace(text)) {
        return defaultOf();
    }
    else {
        return createElement("li", createObj(ofArray([["key", `nav-${Page__get_Key(page)}`], ["className", join(" ", toList(delay(() => {
            if (cssClass == null) {
                return empty();
            }
            else {
                return singleton(cssClass);
            }
        })))], (elems = toList(delay(() => (equals(page, nav.currentPage) ? singleton(text) : singleton(createElement("a", createObj(toList(delay(() => append(singleton(["key", `nav-link-${Page__get_Key(page)}`]), delay(() => append(singleton(["children", text]), delay(() => {
            let pageUrl, queryString;
            return (pageUrl = $007CPageUrl$007C(page), ofArray([["href", (queryString = pageUrl.Query, defaultArgWith(map((tupledArg) => RouterModule_encodeParts(append_1(tupledArg[0], singleton_1(tupledArg[1] + RouterModule_encodeQueryString(queryString))), 2), RouterModule_trySeparateLast(pageUrl.Segments)), () => RouterModule_encodeParts(singleton_1(RouterModule_encodeQueryString(queryString)), 2)))], ["onClick", (e) => {
                Router_goToUrl(e);
            }]]));
        })))))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

function Nav__get_Home(nav) {
    return Nav__page_Z3BF6DD84(nav, new Page(2, []), "🛍️ Shopfoo");
}

function Nav__get_About(nav) {
    return Nav__page_Z3BF6DD84(nav, new Page(0, []), nav.translate((_arg) => TranslationPages_Home__get_About(AppTranslations__get_Home(_arg))));
}

function Nav__get_Admin(nav) {
    return Nav__page_Z3BF6DD84(nav, new Page(1, []), nav.translate((_arg) => TranslationPages_Home__get_Admin(AppTranslations__get_Home(_arg))));
}

function Nav__get_Login(nav) {
    return Nav__page_Z3BF6DD84(nav, new Page(3, []), nav.translate((_arg) => TranslationPages_Home__get_Login(AppTranslations__get_Home(_arg))));
}

function Nav__Product_2648A66C(nav, sku) {
    return Nav__page_Z3BF6DD84(nav, new Page(6, [sku]), sku.Value, "font-semibold");
}

function Nav__get_Products(nav) {
    return Nav__page_Z3BF6DD84(nav, Page_ProductIndexDefaultsWith_Z3D62F06A(Filters__ClearSearchSort), nav.translate((_arg_1) => TranslationPages_Home__get_Products(AppTranslations__get_Home(_arg_1))));
}

function Nav__get_Bazaar(nav) {
    return Nav__page_Z3BF6DD84(nav, Page_ProductIndexDefaultsWith_Z3D62F06A(Filters__ToBazaar_Z3BF3079), nav.translate((_arg_1) => TranslationPages_Home__get_Bazaar(AppTranslations__get_Home(_arg_1))));
}

function Nav__get_Books(nav) {
    return Nav__page_Z3BF6DD84(nav, Page_ProductIndexDefaultsWith_Z3D62F06A(Filters__ToBooks), nav.translate((_arg_1) => TranslationPages_Home__get_Books(AppTranslations__get_Home(_arg_1))));
}

export function AppNavBar(appNavBarInputProps) {
    let elems_2;
    const children = appNavBarInputProps.children;
    const translations = appNavBarInputProps.translations;
    const pageDisplayedInline = appNavBarInputProps.pageDisplayedInline;
    const currentPage = appNavBarInputProps.currentPage;
    const key = appNavBarInputProps.$key;
    const nav = Nav_$ctor_748E64BE(currentPage, translations);
    return createElement("div", createObj(Helpers_combineClasses("navbar", ofArray([["key", `${key}-navbar`], ["className", "bg-base-200 shadow-sm"], (elems_2 = toList(delay(() => {
        let elems_1, elems;
        return append(singleton(createElement("div", createObj(Helpers_combineClasses("breadcrumbs", ofArray([["className", "flex-1"], ["key", "nav-breadcrumbs"], (elems_1 = [createElement("ul", createObj(ofArray([["key", "breadcrumbs-ul"], (elems = toList(delay(() => append(singleton(Nav__get_Home(nav)), delay(() => {
            const matchValue = pageDisplayedInline;
            let matchResult, sku;
            switch (matchValue.tag) {
                case 0: {
                    matchResult = 1;
                    break;
                }
                case 1: {
                    matchResult = 2;
                    break;
                }
                case 3: {
                    matchResult = 3;
                    break;
                }
                case 5: {
                    if (matchValue.fields[0].CategoryFilters != null) {
                        if (matchValue.fields[0].CategoryFilters.tag === 1) {
                            matchResult = 6;
                        }
                        else {
                            matchResult = 5;
                        }
                    }
                    else {
                        matchResult = 4;
                    }
                    break;
                }
                case 6: {
                    matchResult = 7;
                    sku = matchValue.fields[0];
                    break;
                }
                default:
                    matchResult = 0;
            }
            switch (matchResult) {
                case 0: {
                    return empty();
                }
                case 1:
                    return singleton(Nav__get_About(nav));
                case 2:
                    return singleton(Nav__get_Admin(nav));
                case 3:
                    return singleton(Nav__get_Login(nav));
                case 4:
                    return singleton(Nav__get_Products(nav));
                case 5:
                    return append(singleton(Nav__get_Products(nav)), delay(() => singleton(Nav__get_Bazaar(nav))));
                case 6:
                    return append(singleton(Nav__get_Products(nav)), delay(() => singleton(Nav__get_Books(nav))));
                default:
                    return append(singleton(Nav__get_Products(nav)), delay(() => {
                        let matchValue_1;
                        return append((matchValue_1 = sku.Type, (matchValue_1.tag === 1) ? singleton(Nav__get_Books(nav)) : ((matchValue_1.tag === 2) ? singleton(Nav__get_Books(nav)) : ((matchValue_1.tag === 3) ? (empty()) : singleton(Nav__get_Bazaar(nav))))), delay(() => singleton(Nav__Product_2648A66C(nav, sku))));
                    }));
            }
        })))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))), delay(() => children));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
}

